import { SavedAudienceDTO } from './SavedAudience';
import { FacebookCustomAudienceRule } from '../../facebook/audience/Rule';
import {
  CustomAudienceSubType,
  exampleFacebookDataSource,
  exampleFacebookDeliveryStatus,
  exampleFacebookOperationStatus,
  FacebookCustomerFileSource,
  FacebookDataSource,
  FacebookDeliveryStatus,
  FacebookLookalikeSpec,
  FacebookOperationStatus,
} from '../../facebook/audience';

export interface CustomAudience {
  id: number;
  name: string;
  businessID: number;
  facebookID: string;
  description?: string;
  approximateCountLowerBound: number;
  approximateCountUpperBound: number;
  customerFileSource: FacebookCustomerFileSource;
  dataSource: FacebookDataSource;
  deliveryStatus: FacebookDeliveryStatus;
  externalEventSource?: { id: string };
  isValueBased: boolean;
  lookalikeAudienceIDs?: string[];
  lookalikeSpec?: FacebookLookalikeSpec;
  operationStatus: FacebookOperationStatus;
  optOutLink?: string;
  pixelID?: string;
  retentionDays: number;
  rule?: FacebookCustomAudienceRule | null;
  ruleAggregation?: object;
  subtype: CustomAudienceSubType;
  created_at?: number;
  updated_at: number;
  contentUpdatedAt?: number;
}

export const exampleCustomAudience: CustomAudience = {
  id: 1,
  name: 'Custom Audience',
  businessID: 1,
  facebookID: '123',
  description: 'this is a custom audience',
  approximateCountLowerBound: 55000,
  approximateCountUpperBound: 60000,
  customerFileSource: FacebookCustomerFileSource.BOTH_USER_AND_PARTNER_PROVIDED,
  dataSource: exampleFacebookDataSource,
  deliveryStatus: exampleFacebookDeliveryStatus,
  isValueBased: false,
  operationStatus: exampleFacebookOperationStatus,
  retentionDays: 120,
  subtype: CustomAudienceSubType.APP,
  updated_at: 123,
};

export interface CustomAudienceDTO extends SavedAudienceDTO {
  customer_file_source?: FacebookCustomerFileSource;
  is_value_based?: boolean;
  retention_days: number;
  subtype?: CustomAudienceSubType;
  prefill?: boolean;
  rule?: FacebookCustomAudienceRule;
}

export interface RelatedCustomAudiences {
  originalAudiences: CustomAudience[];
  includedAudiences: CustomAudience[];
  excludedAudiences: CustomAudience[];
}
